import { withStyles } from '@material-ui/core';

import CalendarTopBar from './component';
import styles from './styles';

export default withStyles(styles)(CalendarTopBar);
